export const odataOperators = [
  { Name: "Equal", Value: "eq", Symbol: "=" },
  { Name: "Not Equal", Value: "ne", Symbol: "!=" },
  { Name: "Greater Than", Value: "gt", Symbol: ">" },
  { Name: "Greater Than or Equal", Value: "ge", Symbol: ">=" },
  { Name: "Less Than", Value: "lt", Symbol: "<" },
  { Name: "Less Than or Equal", Value: "le", Symbol: "<=" },
  // { Name: "And", Value: "and" },
  // { Name: "Or", Value: "or" },
  // { Name: "Not", Value: "not" },
  // { Name: "Add", Value: "add" },
  // { Name: "Subtract", Value: "sub" },
  // { Name: "Multiply", Value: "mul" },
  // { Name: "Divide", Value: "div" },
  // { Name: "Modulo", Value: "mod" },
  // { Name: "Has", Value: "has" },
  // { Name: "In", Value: "in" },
  { Name: "Contains", Value: "contains", Symbol: "contains" },
  { Name: "Starts With", Value: "startswith", Symbol: "startswith" },
  { Name: "Ends With", Value: "endswith", Symbol: "endswith" },
  // { Name: "Length", Value: "length" },
  // { Name: "Index Of", Value: "indexof" },
  // { Name: "Substring", Value: "substring" },
  // { Name: "To Lower", Value: "tolower" },
  // { Name: "To Upper", Value: "toupper" },
  // { Name: "Trim", Value: "trim" },
  // { Name: "Concat", Value: "concat" },
  // { Name: "Year", Value: "year" },
  // { Name: "Month", Value: "month" },
  // { Name: "Day", Value: "day" },
  // { Name: "Hour", Value: "hour" },
  // { Name: "Minute", Value: "minute" },
  // { Name: "Second", Value: "second" },
  // { Name: "Fractional Seconds", Value: "fractionalseconds" },
  // { Name: "Date", Value: "date" },
  // { Name: "Time", Value: "time" },
  // { Name: "Total Offset Minutes", Value: "totaloffsetminutes" },
  // { Name: "Now", Value: "now" },
  // { Name: "Min Date Time", Value: "mindatetime" },
  // { Name: "Max Date Time", Value: "maxdatetime" },
  // { Name: "Floor", Value: "floor" },
  // { Name: "Ceiling", Value: "ceiling" },
  // { Name: "Round", Value: "round" },
  // { Name: "Cast", Value: "cast" },
  // { Name: "Is Of", Value: "isof" },
  // { Name: "Geo Distance", Value: "geo.distance" },
];